import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
    static targets = ["content"]; // We only need the content target

    connect() {
        console.log("Collapse controller connected"); // For debugging
        // Set initial height based on screen size
        this.setInitialHeight();
        // Listen for window resize to adjust height
        window.addEventListener("resize", () => this.setInitialHeight());
    }

    disconnect() {
        // Clean up resize listener
        window.removeEventListener("resize", () => this.setInitialHeight());
    }

    setInitialHeight() {
        this.element.style.height = window.innerWidth < 768 ? "200px" : "280px";
    }

    toggle(event) {
        event.preventDefault();

        // Get the base target name (e.g., "budget", "analysis", "priority")
        const targetId = event.currentTarget.dataset.collapseTarget;

        // Find the content element within this controller's element
        const contentElement = this.element.querySelector(`[data-collapse-target="${targetId}-content"]`);
        const showTextElement = event.currentTarget.querySelector("[data-collapse-show]");
        const hideTextElement = event.currentTarget.querySelector("[data-collapse-hide]");

        if (!contentElement) {
            console.error(`Could not find content element for target: ${targetId}-content`);
            return;
        }

        if (contentElement.classList.contains("tw-hidden")) {
            // Show content
            contentElement.classList.remove("tw-hidden");
            showTextElement.classList.add("tw-hidden");
            hideTextElement.classList.remove("tw-hidden");
            this.element.style.height = "auto";
        } else {
            // Hide content
            contentElement.classList.add("tw-hidden");
            showTextElement.classList.remove("tw-hidden");
            hideTextElement.classList.add("tw-hidden");
            this.setInitialHeight();
        }
    }
}
